export default __webpack_public_path__ + "static/emotive_dreams-403f5ca769c1675a6684471c9f03a99d.png";